export default __webpack_public_path__ + "static/1-6-1-0-1134bd0f96e9fb84e74843659d6338e2.jpg";